import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ProviderInviteAcceptPage } from "@/features/provider-invite/provider-invite-accept-page";

/**
 * Public roster-invitation acceptance page: `${APP_HOST}/provider-invite?token=<raw-token>`
 * (see `inngest-affiliation-invitation-send.ts`). Deliberately a top-level
 * route — not nested under `_provider` — so it renders for signed-out
 * visitors too instead of bouncing through the authenticated loader's
 * sign-in redirect (which would drop the token). The token stays in the URL
 * throughout: it does nothing on its own (acceptance needs a logged-in,
 * email-matching account and is consumed once accepted), and the account-switch
 * sign-in flow round-trips it via the `redirect` param
 * (`buildProviderInviteRedirect`).
 */
export const Route = createFileRoute("/provider-invite")({
  validateSearch: z.object({
    token: z.string().optional(),
  }),
  component: ProviderInviteRoute,
});

function ProviderInviteRoute() {
  const { token } = Route.useSearch();
  return <ProviderInviteAcceptPage token={token} />;
}
